export function useDataKey(key: string) {
  const cookieStore = useCookieStore()

  return `${key}-${cookieStore.countryCookie}-${cookieStore.languageCookie}`
}
